// extracted by mini-css-extract-plugin
export default {"inputText":"EvaluatorEmail_inputText__54CrN","error":"EvaluatorEmail_error__kqoY-"};